import styles from './index.module.css';
import DOMPurify from 'dompurify';
import Notes from '../notes';
const Battery = ({ textData }) => {
  return (
    <div className={styles.ctn}>
      <h1
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text30']),
        }}
      ></h1>
      <h5
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text31']),
        }}
      ></h5>
      <div className={styles.content}>
        <video
          autoPlay
          playsInline
          muted
          preload="true"
          src="https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-battery.mp4"
          poster="https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-battery-cover.jpg"
        ></video>

        <div className={styles.text}>
          {/* <div className={styles.textBox}>
            <h6
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text32']),
              }}
            ></h6>
            <h2
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text33']),
              }}
            ></h2>
          </div> */}
          <div className={styles.textBox}>
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text34']),
              }}
            ></h5>
            <h2
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text35']),
              }}
            ></h2>
          </div>

          <div className={styles.textBox}>
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text36']),
              }}
            ></h5>
            <h3
              className={`mainText`}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text37']),
              }}
            ></h3>
          </div>
        </div>
      </div>

      <Notes textData={textData}/>
    </div>
  );
};

export default Battery;
